document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".product__essentials-carousel")
  const prevButton = document.getElementById("prev-button")
  const nextButton = document.getElementById("next-button")
  const footerItems = document.querySelectorAll(".product__essentials-carousel-footer__image")

  const zoomImage = document.getElementsByClassName("currentSlide")

  let currentIndex = 0
  let startX = 0
  let endX = 0

  if (!carousel) return

  // Una diapositiva por medio: <img>, <deferred-media> (vídeo) o modelo 3D.
  // Ojo: el póster del vídeo también es un <img>, por eso solo se cogen hijos directos.
  function getSlides() {
    return carousel.querySelectorAll(":scope > img, :scope > deferred-media, :scope > .product-media-modal__model")
  }

  if (!getSlides().length) return

  // Listen for modal carousel open event
  document.addEventListener("modalCarouselOpen", function (event) {
    const initialMediaId = event.detail.initialMediaId
    if (initialMediaId) {
      currentIndex = findSlideIndex(initialMediaId)
      showImage(currentIndex)
    }
  })

  function findSlideIndex(mediaId) {
    const slides = getSlides()
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute("data-media-id") === mediaId) return i
    }
    return 0
  }

  function pauseSlide(slide) {
    slide.querySelectorAll("video").forEach((video) => video.pause())
  }

  function isModalOpen() {
    const modal = carousel.closest("product-modal")
    return !modal || modal.hasAttribute("open")
  }

  function playSlide(slide) {
    if (slide.nodeName !== "DEFERRED-MEDIA" || !isModalOpen()) return
    if (!slide.getAttribute("loaded")) {
      slide.loadContent(false)
    }
    const video = slide.querySelector("video")
    if (video) {
      video.muted = true
      video.playsInline = true
      const playPromise = video.play()
      if (playPromise) playPromise.catch(() => {})
    }
  }

  carousel.addEventListener("touchstart", function (e) {
    if (window.innerWidth > 768) return // Only on mobile
    if (e.touches.length > 1) return // Ignore if more than one finger (pinch)
    startX = e.touches[0].clientX
  })

  carousel.addEventListener("touchmove", function (e) {
    if (window.innerWidth > 768) return // Only on mobile
    if (e.touches.length > 1) return // Ignore if more than one finger (pinch)
    endX = e.touches[0].clientX
  })

  carousel.addEventListener("touchend", function (e) {
    if (window.innerWidth > 768) return
    if (e.changedTouches.length > 1) return

    // Si la imagen actual está en modo zoom, no hacer swipe
    const currentSlide = getSlides()[currentIndex]
    if (currentSlide && currentSlide.classList.contains("enlarged")) return

    if (startX && endX) {
      if (startX - endX > 50) {
        nextImage()
      } else if (endX - startX > 50) {
        prevImage()
      }
    }
    // Reinicia los valores para evitar falsos positivos
    startX = 0
    endX = 0
  })

  // Vídeo decorativo: no se pausa con un toque; si el navegador lo ha parado, un toque lo reanuda
  carousel.addEventListener("click", function (e) {
    const slide = e.target.closest("deferred-media")
    if (!slide) return
    const video = slide.querySelector("video")
    if (video && video.paused) {
      const playPromise = video.play()
      if (playPromise) playPromise.catch(() => {})
    } else if (!video) {
      playSlide(slide)
    }
  })

  function showImage(index) {
    const slides = getSlides()

    slides.forEach(function (slide, i) {
      if (i === index) {
        slide.style.display = "block"
      } else {
        slide.style.display = "none"
        pauseSlide(slide)
      }
    })

    if (slides[index]) playSlide(slides[index])

    // Indicador de drag
    const bar = document.querySelector(".carousel-drag-indicator-bar")
    if (bar) {
      const barWidth = 100 / slides.length
      bar.style.width = barWidth + "%"
      bar.style.left = barWidth * index + "%"
    }
  }

  function prevImage() {
    const total = getSlides().length
    currentIndex = (currentIndex - 1 + total) % total
    showImage(currentIndex)
  }

  function nextImage() {
    const total = getSlides().length
    currentIndex = (currentIndex + 1) % total
    showImage(currentIndex)
  }

  function changeImageByFooter(event) {
    const footerItem = event.currentTarget
    const index = footerItem.getAttribute("data-media-index")
    if (!isNaN(index)) {
      currentIndex = parseInt(index)
      showImage(currentIndex)
    }
  }

  if (prevButton) prevButton.addEventListener("click", prevImage)
  if (nextButton) nextButton.addEventListener("click", nextImage)

  footerItems.forEach(function (item) {
    item.addEventListener("click", changeImageByFooter)
  })

  for (let i = 0; i < zoomImage.length; i++) {
    zoomImage[i].addEventListener("click", function () {
      this.classList.toggle("enlarged")
    })
  }

  // Al cerrar el modal: parar el vídeo del zoom y reanudar los vídeos en autoplay
  // de la galería (ModalDialog.show los pausa todos con pauseAllMedia)
  document.body.addEventListener("modalClosed", function () {
    getSlides().forEach(pauseSlide)
    document.querySelectorAll("media-gallery video[autoplay]").forEach(function (video) {
      const playPromise = video.play()
      if (playPromise) playPromise.catch(() => {})
    })
  })

  showImage(currentIndex)
})
